import React from 'react';
import { Collapse, Table } from 'antd';
import { Route as RouteIcon, ClipboardCheck } from 'lucide-react';
import { StatusTag, EmptyState } from '../../../common';
import { PanelHeader } from './PromoterCalendar';
import { useRouteInfo } from './promoterRoute.controller';
import { t } from '../../../../company/labels';

function Route({ storeChecks, loading, stores, navigateStoreCheck }) {
    const info = useRouteInfo(storeChecks, stores);

    const TableRoute = [
        {
            title: 'Orden',
            key: 'order',
            width: 80,
            align: 'center',
            render: (_, __, index) => (
                <span className="inline-flex h-6 min-w-[24px] items-center justify-center rounded-md bg-primary-50 px-1.5 text-xs font-semibold text-primary-600 tabular-nums">
                    {index + 1}
                </span>
            )
        },
        {
            title: 'Auditoría',
            dataIndex: 'auditName',
            key: 'auditName',
            render: (text, record) => (
                <button
                    type="button"
                    onClick={() => navigateStoreCheck(record._id)}
                    className="text-left text-sm font-medium text-primary-600 hover:text-primary-700 hover:underline">
                    {text}
                </button>
            )
        },
        {
            title: 'Piso de Venta',
            dataIndex: 'storeName',
            key: 'storeName',
            render: (text) => <span className="text-sm text-surface-700">{text}</span>
        },
        {
            title: 'Tiempo en Piso',
            dataIndex: 'timeInStore',
            key: 'timeInStore',
            align: 'right',
            render: (text) => (
                <StatusTag tone={text > 30 ? 'warning' : 'success'} className="tabular-nums">
                    {text} min
                </StatusTag>
            )
        }
    ];

    return (
        <div className="shelf-card overflow-hidden">
            <Collapse
                ghost
                items={[
                    {
                        key: 1,
                        styles: { body: { padding: 0 } },
                        label: (
                            <PanelHeader
                                icon={<RouteIcon />}
                                title={<span>Recorrido del {t('promotor')}</span>}
                                count={<StatusTag tone="success">{info.length} auditorías</StatusTag>}
                            />
                        ),
                        children:
                            info.length === 0 ? (
                                <EmptyState icon={<ClipboardCheck />} title="No hay auditorías registradas para este día" />
                            ) : (
                                <div className="border-t border-surface-100 [&_.ant-pagination]:px-5">
                                    <Table
                                        columns={TableRoute}
                                        loading={loading}
                                        size="middle"
                                        dataSource={info}
                                        scroll={{ x: 'max-content' }}
                                        pagination={{
                                            pageSize: 20,
                                            showTotal: (total) => `Total ${total} auditorías`
                                        }}
                                        rowKey="key"
                                    />
                                </div>
                            )
                    }
                ]}
            />
        </div>
    );
}

export default Route;
